import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

axios.defaults.baseURL = process.env.VUE_APP_API_URL || 'https://api.eurekali-point.com'


function isAccountingUrl(url) {
  if (!url) return false
  const u = typeof url === 'string' ? url : (url.url || '')
  if (u.includes('verify-accounting-code')) return false
  return (
    u.includes('get-invoices-v2') ||
    u.includes('get-refunds-v2') ||
    u.includes('get-autofacturations-v2') ||
    u.includes('get-cash-shipments') ||
    u.includes('edit-invoice') ||
    u.includes('edit-refund') ||
    u.includes('edit-autofacturation') ||
    u.includes('update-cash-shipment') ||
    u.includes('/reports') ||
    u.includes('export-shipments')
  )
}

axios.interceptors.request.use((config) => {
  const token = store.state.accountingToken
  if (token && isAccountingUrl(config.url)) {
    config.headers['X-Accounting-Access'] = token
  }
  return config
})

// URL d'authentification : leurs erreurs sont déjà expliquées par l'écran de connexion
function isAuthUrl(url) {
  const u = typeof url === 'string' ? url : (url?.url || '')
  return u.includes('/admin/login/') || u.includes('/admin/2fa/')
}

// Traduit une erreur d'API en message honnête pour l'utilisateur.
// Leçon du 15/09/2026 : un 403 avalé par les vues affichait « aucune commande » à des
// admins simplement bloqués par la règle « IP autorisée OU 2FA » — une journée perdue.
function expliquerErreur(err) {
  if (!err.response) {
    return { kind: 'reseau', message: "Le serveur ne répond pas (réseau ou moteur arrêté). Réessayez dans un instant." }
  }
  const status = err.response.status
  const detail = String(err.response.data?.detail || err.response.data?.error || '')
  if (status === 401) {
    return { kind: 'session', message: "Votre session a expiré ou n'est plus valide. Reconnectez-vous." }
  }
  if (status === 403) {
    if (/double authentification|IP non autoris/i.test(detail)) {
      return { kind: 'acces', message: "Accès refusé : votre adresse IP n'est pas dans la liste autorisée et la double authentification n'est pas activée sur votre compte. Activez-la dans « Securite » pour travailler depuis n'importe où." }
    }
    return { kind: 'refus', message: "Accès refusé (" + (detail || 'droits insuffisants') + ")." }
  }
  if (status >= 500) {
    return { kind: 'serveur', message: "Erreur du serveur (" + status + ") : les données n'ont pas pu être chargées. Réessayez, puis prévenez le support si ça persiste." }
  }
  return null
}

axios.interceptors.response.use(
  (res) => res,
  (err) => {
    let refusComptable = false
    if (err.response?.status === 403 && err.config && isAccountingUrl(err.config.url)) {
      const msg = err.response?.data?.error || ''
      if (msg.toLowerCase().includes('accounting')) {
        store.commit('setAccountingToken', '')
        refusComptable = true   // géré par l'écran du code comptable, pas de bandeau
      }
    }
    if (!refusComptable && !(err.config && isAuthUrl(err.config.url))) {
      const explication = expliquerErreur(err)
      // Plusieurs appels échouent souvent en rafale : « session expirée » (la cause première)
      // ne doit pas être écrasée par les messages des appels suivants.
      const actuel = store.state.apiError
      if (explication && !(actuel && actuel.kind === 'session' && explication.kind !== 'session')) {
        store.commit('setApiError', explication)
        if (explication.kind === 'session') {
          // Jeton mort : on le retire et on renvoie à la connexion en mémorisant la page voulue
          store.commit('removeToken')
          sessionStorage.removeItem('token')
          axios.defaults.headers.common['Authorization'] = ''
          const ici = router.currentRoute.value?.path || '/'
          if (ici !== '/login' && ici !== '/') router.push({ name: 'LogIn', query: { to: ici } })
        }
      }
    }
    return Promise.reject(err)
  }
)

createApp(App).use(store).use(router, axios).mount('#app')

